
<template>
  <div>
    OneTaskDetailsPage
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'OneTaskDetailsPage',
  //mixins: [ validations ],
  components: {
    //ComponentName: () => import(''),
  },
  data() {
    return {
      
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>